import FrameSampler from '../frameSampler'
import MotionDetector from '../motionDetector'

const LEVEL_THRESHOLD = 2
// Once motion is seen, hold the "YES" state for this long before falling back
// to "NO". Without it the readout flickers on every still frame between moves.
const HOLD_MS = 600

// Noise below this (after smoothing) reads as "no motion" -> shown as 0, so the
// Level doesn't twitch while the scene is still.
const NOISE_FLOOR = 0.6

export default function createMotionDetector() {
    let sampler = null
    let motion = null
    let lastMovingAt = 0
    let lastBox = null
    let levelEma = 0

    return {
        id: 'motion',
        label: 'Motion Detection',
        accent: '#a855f7',

        async load() {
            if (!sampler) sampler = new FrameSampler()
            if (!motion) motion = new MotionDetector()
        },

        async detect({ video, stamp }) {
            if (!sampler || !motion) return null
            const frame = sampler.sample(video, stamp)
            const res = motion.analyse(
                frame,
                sampler.width,
                sampler.height,
                { pixelThreshold: 25 },
                null
            )
            const now = performance.now()
            const rawMoving = res.level >= LEVEL_THRESHOLD
            if (rawMoving) {
                lastMovingAt = now
                if (res.box) lastBox = res.box
            }
            // Debounced state: stays YES for HOLD_MS after the last movement.
            const moving = now - lastMovingAt < HOLD_MS
            const box = moving ? res.box || lastBox : null
            const boxes = box ? [{ ...box, label: 'Motion' }] : []
            // Smooth the level and drop sensor noise to 0 so it stays steady
            // when still and tracks real motion instead of twitching.
            levelEma = levelEma * 0.7 + res.level * 0.3
            const shownLevel = levelEma < NOISE_FLOOR ? 0 : levelEma
            return {
                boxes,
                insights: [
                    { label: 'Motion Detection', value: moving ? 'YES' : 'NO' },
                    // { label: 'Level', value: `${shownLevel.toFixed(1)}%` },
                ],
            }
        },

        reset() {
            if (motion) motion.reset()
            lastMovingAt = 0
            lastBox = null
            levelEma = 0
        },
        dispose() {
            sampler = null
            motion = null
        },
    }
}
